import React from "react";

//@material-ui
import {
  Modal,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  DialogTitle,
} from "@material-ui/core";

//@context
import { GameContext } from "../../context/GameContext";

import { PlaceholderImage } from "../../assets/svg";

export const HelpModal = ({ open, handleClose }) => {
  return (
    <Modal
      role="dialog"
      className="help_modal"
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby="modal-help"
      aria-describedby="modal-help-description"
    >
      <div className="modal-content_container">
        <div className="modal_header">
          <h2 id="modal-help">Vem hör till vilket parti?</h2>
          <button
            className="help-modal-close_button sm_btn"
            onClick={() => handleClose(false)}
            aria-label="Stäng spelinstruktioner"
          ></button>
        </div>
        <div className="modal-content">
          <p id="modal-help-description">
            Para ihop politikerna med rätt parti. <br />
            Klicka på en politiker och sen på det du tror är rätt parti. <br />
            Eller tvärtom, börja med att klicka på en partisymbol och välj sedan
            en politiker. <br />
            Om du vill ändra dig klickar du på politikern en gång till och gör
            om.
          </p>
          <h2>Byt spel</h2>
          <p>
            Vill du byta spel och lära dig vilka politiker som finns i din
            kommun eller region?
            <br />
            <a className="link" href={`${process.env.PUBLIC_URL}/alla-spel`}>
              Kolla i listan om din kommun/region finns tillgänglig.
            </a>
          </p>
        </div>
      </div>
    </Modal>
  );
};

export const ResultModal = ({ open, onClick, clearedCards, cards }) => {
  const { correct } = React.useContext(GameContext);

  const restart = (e) => {
    open && onClick(e);
  };

  const close = () => {
    window.location.href = process.env.REACT_APP_SV_URL;
  };

  const resultItem = (arr) => {
    var imgArr = {};
    const [first, second] = arr;
    var img1 = cards.find((o) => o.id === first);
    var img2 = cards.find((o) => o.id === second);
    if (img1.image_class) {
      imgArr.person = { image: img1.image, name: img1.name };
      imgArr.party = { image: img2.image, name: img2.name };
    } else {
      imgArr.person = { image: img2.image, name: img2.name };
      imgArr.party = { image: img1.image, name: img1.name };
    }
    return imgArr;
  };

  return (
    <Dialog
      className="result_modal"
      open={open}
      disableEscapeKeyDown
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Ditt resultat</DialogTitle>
      <DialogContent>
        <DialogContentText id="dialog-description">
          <strong>Bra jobbat!</strong> Du fick <strong>{correct} rätt</strong>{" "}
          av {clearedCards.length} möjliga
          <br />
          Utmana dig själv och spela igen eller gå tillbaka till Mittval genom
          att avsluta spelet.
        </DialogContentText>
      </DialogContent>
      <DialogActions className="button_container">
        <Button className="btn modal_btn" onClick={restart}>
          Spela igen!
        </Button>
        <Button className="btn modal_btn" onClick={close}>
          Avsluta spel
        </Button>
      </DialogActions>
      <DialogContent className="result-list_container">
        {correct > 0 ? (
          <DialogContentText id="dialog-description">
            Dina rätta svar
          </DialogContentText>
        ) : null}
        <ul className="result-list">
          {clearedCards.map((obj, index) => {
            if (obj.matched) {
              const result = resultItem(obj.cards);

              return (
                <li key={index} className="result-list_item">
                  <div className="column">
                    <p className="result--name">{result.person.name}</p>
                    {result.person.image && (
                      <img
                        className="result--img"
                        src={result.person.image}
                        alt=""
                      />
                    )}
                    {result.person.image === null && (
                      <PlaceholderImage
                        className="result--img"
                        aria-hidden="true"
                      />
                    )}
                  </div>
                  <div className="column">
                    <p
                      className={`result--name ${
                        result.party.image === "" && "only-text"
                      }`}
                    >
                      {result.party.name}
                    </p>
                    {result.party.image !== "" && (
                      <img
                        className="result--img"
                        src={result.party.image}
                        alt=""
                      />
                    )}
                  </div>
                </li>
              );
            }
            return null;
          })}
        </ul>
      </DialogContent>
    </Dialog>
  );
};
